import { render, staticRenderFns } from "./measurements.vue?vue&type=template&id=378fb8bd&scoped=true"
import script from "./measurements.vue?vue&type=script&lang=js"
export * from "./measurements.vue?vue&type=script&lang=js"
import style0 from "./measurements.vue?vue&type=style&index=0&id=378fb8bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378fb8bd",
  null
  
)

export default component.exports